// Import global utils
import { isDefined } from '@automator/shared/utils/is-defined';
import { isEmpty } from '@automator/shared/utils/is-empty';

/**
 * Returns the list of integrations
 *
 * @param {Object} filters Object with custom filters. Check the filters object below
 * @return {String}         The integrations
 */
const getIntegrations = ( filters = {} ) => {
	// Check if it has options defined
	if ( isEmpty( filters ) ) {
		return UncannyAutomator.integrations;
	}

	// Default filters
	filters = Object.assign( {

		/**
		 * True if it MUST have them
		 * false if it MUST NOT have them
		 * null to ignore the property
		 *
		 * @type {Boolean}
		 */
		triggers: null,
		actions: null,
		conditions: null,

		/**
		 * Custom callback
		 *
		 * @type {Callback}
		 */
		customFilter: null,

	}, filters );

	// Filter conditions
	const filteredConditions = {};

	Object.entries( UncannyAutomator.integrations ).map( ( [ integrationID, integration ] ) => {
		// Default value
		let shouldAdd = true;

		// Check custom callback
		if ( isDefined( filters.customFilter ) ) {
			shouldAdd = filters.customFilter( integration );
		}

		// Check triggers
		if ( isDefined( filters.triggers ) ) {
			// Check cases
			if (
				// Integrations that MUST have triggers, but don't
				( filters.triggers && ! integration.items.triggers.hasTriggers )

				// Integrations that MUST NOT have triggers, but do
				|| ( ! filters.triggers && integration.items.triggers.hasTriggers )
			) {
				shouldAdd = false;
			}
		}

		// Check actions
		if ( isDefined( filters.actions ) ) {
			// Check cases
			if (
				// Integrations that MUST have actions, but don't
				( filters.actions && ! integration.items.actions.hasActions )

				// Integrations that MUST NOT have actions, but do
				|| ( ! filters.actions && integration.items.actions.hasActions )
			) {
				shouldAdd = false;
			}
		}

		// Check conditions
		if ( isDefined( filters.conditions ) ) {
			// Check cases
			if (
				// Integrations that MUST have conditions, but don't
				( filters.conditions && ! integration.conditions.hasConditions )

				// Integrations that MUST NOT have conditions, but do
				|| ( ! filters.conditions && integration.conditions.hasConditions )
			) {
				shouldAdd = false;
			}
		}

		// Add it
		if ( shouldAdd ) {
			filteredConditions[ integrationID ] = integration;
		}
	} );

	return filteredConditions;
};

export default getIntegrations;
